import script from "./TunnelCorridorInspection.vue?vue&type=script&setup=true&lang=js"
export * from "./TunnelCorridorInspection.vue?vue&type=script&setup=true&lang=js"

import "./TunnelCorridorInspection.vue?vue&type=style&index=0&id=0fcc6482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fcc6482"]])

export default __exports__